export const TEST_ID = 'uploadCard';

export const CANCEL_BUTTON_TEST_ID = 'uploadCardCancel';

export const CONTINUE_BUTTON_TEST_ID = 'uploadCardContinue';

export const ERROR_BANNER_TEST_ID = 'uploadCardErrorBanner';
